import { trpc } from '@/shared/api';

/** 대표 사진은 자주 바뀌지 않는다 — 홈을 오가며 같은 카테고리 사진을 다시 묻지 않는다. */
const COVER_STALE_MS = 5 * 60_000;

/**
 * 카테고리별 대표 사진(products.list, 카테고리마다 한 건) — 그 카테고리(대분류면 소분류까지)의
 * 추천순 첫 공개 상품 대표사진 주소. 상품이나 사진이 없으면 null, 아직 못 받았으면 Map 에 없다.
 */
export const useCategoryCoverImagesQuery = (
  categoryIds: readonly string[],
): ReadonlyMap<string, string | null> => {
  const results = trpc.useQueries((t) =>
    categoryIds.map((categoryId) =>
      t.products.list(
        { categoryId, sort: 'RECOMMENDED', page: 1, limit: 1 },
        { staleTime: COVER_STALE_MS, retry: false },
      ),
    ),
  );
  const covers = new Map<string, string | null>();
  for (const [index, categoryId] of categoryIds.entries()) {
    const data = results[index]?.data;
    if (data !== undefined) covers.set(categoryId, data.items[0]?.thumbnail?.url ?? null);
  }
  return covers;
};
